import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { Loader } from 'lucide-react';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
    <Suspense  fallback={<Loader className='size-6 animate-spin text-primary-600'/>}>
       <App />
      
    </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);

